import { forEach, has, reduce } from 'lodash';

export const getAllAgents = <T extends { agentIds?: string[] }>(list: T[]): Record<string, T[]> => {
  return reduce(
    list,
    (acc: Record<string, T[]>, item) => {
      forEach(item.agentIds, agentId => {
        if (!has(acc, agentId)) {
          acc[agentId] = [];
        }
        acc[agentId].push(item);
      });

      return acc;
    },
    {}
  );
};
